module.exports = __webpack_public_path__ + "img/Image_Filled_16px_Icon.05853821.svg";